
function Footer() {
  return (
    <div className="nk-footer">
        <div className="container-fluid">
            <div className="nk-footer-wrap justify-content-center">
                <div className="nk-footer-copyright">
                    &copy; 2024 Z1 <a href="#" target="_blank" rel="noreferrer" className="text-reset">Education Platform</a>
                </div>

            </div>
        </div>
    </div>
  )
}

export default Footer